<div class="main-content pt-4 mt-0">
  <div class="container-fluid">
    <div class="row justify-content-center">
      <div class="col-3 col-md-2" *ngFor="let card of resumenCards; index as i">
        <!-- [class]="i < 2 ? 'col-md-6' : 'col-md-4'" -->
        <div
          class="card card-stats"
          [ngClass]="{ 'card-stats__selected': i === 0 }"
          [routerLink]="card.route"
          [style.cursor]="card.route ? 'pointer' : 'default'"
        >
          <div class="card-body">
            <div class="row">
              <div class="col-12 col-md-6 col-lg-6">
                <div
                  class="icon-big text-center text-dark rounded shadow"
                  [ngClass]="card.bgClass"
                >
                  <i [class]="card.icon"></i>
                </div>
              </div>
              <div class="col-7 d-flex flex-column justify-content-center">
                <p class="card-category mb-0">{{ card.label }}</p>
                <h4
                  class="card-title mb-0"
                  [ngClass]="{ 'text-dark': i === 0, 'text-white': i !== 0 }"
                >
                  {{ card.value }}
                </h4>
              </div>
            </div>
          </div>
          <div class="card-footer">
            <div class="stats">
              <small [class]="i == 0 ? 'desc__selected' : 'desc'">{{
                card.desc
              }}</small>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-8">
        <div class="card">
          <div class="card-header card-header-icon">
            <div class="card-icon">
              <i class="material-icons">chat</i>
            </div>
            <h4 class="card-title">Conservation #1</h4>
          </div>
          <div class="card-body">
            <form [formGroup]="form" (ngSubmit)="onSubmit()">
              <!-- Información Básica -->
              <div class="row">
                <div class="col-md-6">
                  <div class="form-group">
                    <label class="bmd-label-floating" for="user">User</label>
                    <input
                      type="text"
                      class="form-control"
                      id="user"
                      formControlName="user"
                    />
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label class="bmd-label-floating" for="ip">IP</label>
                    <input
                      type="text"
                      class="form-control"
                      id="ip"
                      formControlName="ip"
                    />
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6">
                  <div class="form-group">
                    <label class="bmd-label-floating" for="duration"
                      >Duration</label
                    >
                    <input
                      type="text"
                      class="form-control"
                      id="duration"
                      formControlName="duration"
                    />
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label class="bmd-label-floating" for="intention"
                      >Intention</label
                    >
                    <input
                      type="text"
                      class="form-control"
                      id="intention"
                      formControlName="intention"
                    />
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-md-6">
                  <div class="form-group">
                    <label class="bmd-label-floating" for="summary"
                      >Summary</label
                    >
                    <textarea
                      type="text"
                      class="form-control"
                      id="summary"
                      formControlName="summary"
                      rows="4"
                    ></textarea>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label class="bmd-label-floating" for="conclusions"
                      >Coonclusions</label
                    >
                    <textarea
                      type="text"
                      class="form-control"
                      id="conclusions"
                      formControlName="conclusions"
                      rows="4"
                    ></textarea>
                  </div>
                </div>
              </div>

              <div class="row text-center">
                <div class="col-md-12">
                  <button class="btn btn-dark btn-sm btn-end">
                    Complete conversation
                  </button>
                  <button class="btn btn-dark btn-sm btn-end">
                    Export
                  </button>
                  <button class="btn btn-dark btn-sm btn-end">
                    Report
                  </button>
                </div>
              </div>
              <div class="clearfix"></div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
